import { render } from "./number-notification.vue?vue&type=template&id=bb5f5a1e&scoped=true"
import script from "./number-notification.vue?vue&type=script&lang=js"
export * from "./number-notification.vue?vue&type=script&lang=js"

import "./number-notification.vue?vue&type=style&index=0&id=bb5f5a1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5f5a1e"]])

export default __exports__